function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 16"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.79 11.82L3.32 8.36a.53.53 0 010-.76l.76-.75c.2-.21.54-.21.75 0l2.34 2.33 5-5c.2-.21.55-.21.75 0l.76.75c.2.21.2.55 0 .76l-6.14 6.13c-.2.2-.54.2-.75 0z",
  clipRule: "evenodd"
})));